import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { S, Icon, Icons } from '../regureStyles';
import { usePermission, useFeature } from '../../hooks/useAccess';

const Header = ({ setShowAddModal }) => {
  const history = useHistory();
  const { t } = useTranslation();
  // Offer only what this caller and this tenant can actually use. Both
  // endpoints already refuse otherwise — riskCarriers:write is not granted to
  // claims staff, and /bordereaux 403s when the module is off.
  const canWriteCarriers = usePermission('riskCarriers', 'write');
  const bordereauxEnabled = useFeature('bordereaux');

  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.riskCarriers.breadcrumb', { defaultValue: 'Administration' })} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.riskCarriers.breadcrumbCurrent', { defaultValue: 'Risk Carriers' })}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.riskCarriers.title', { defaultValue: 'Risk Carriers' })}</div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        {bordereauxEnabled && <button
          onClick={() => history.push('/bordereaux')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '9px 16px',
            background: S.bgCard,
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: 'pointer',
          }}
        >
          <Icon name='file-text' color={S.textMuted} size={15} /> {t('screens.riskCarriers.bordereauxHistory', { defaultValue: 'Bordereaux History' })}
        </button>}
        {canWriteCarriers && <button
          onClick={() => setShowAddModal(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '9px 16px',
            background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          <Icon name='plus' color='#fff' size={16} /> {t('screens.riskCarriers.addCarrier', { defaultValue: 'Add Carrier' })}
        </button>}
      </div>
    </header>
  );
};

export default Header;
